import { LoadingDots } from '@expressable/syntax-ds';
import React from 'react';
import { useEffectOnce } from 'react-use';
import { useSignupDirectCtx } from '../context';
import { getJotformRegistrationFormLink } from '../misc/jotformRegistrationForm';
import { useTrack } from 'utils/hooks/useMixPanel';
import { DIRECT_SIGNUP_MIXPANEL_EVENTS } from '../misc/mixpanelTracking';
import { useNavigate } from 'react-router-dom';
import { routes } from 'router/routes';

/**
 * @TODO(juan)
 *
 * a bunch of code is commented here while landing page is experimented with
 */

export const SignupJotformRedirect: React.FC = () => {
  useTrack(DIRECT_SIGNUP_MIXPANEL_EVENTS.STEPS.REDIRECT_TO_JOTFORM.FULL_FORM);

  const { filters, resumedLeadState } = useSignupDirectCtx();

  const navigate = useNavigate();

  useEffectOnce(() => {
    if (filters) {
      const jotformURL = getJotformRegistrationFormLink(filters, resumedLeadState?.leadID);

      window.location.href = jotformURL;
    } else {
      navigate(routes.signupDirect.base);
    }
  });

  return <LoadingDots className="flex flex-col h-max static" />;
};
